import Calibration from '@/components/pages/activator/Calibration'
import RollWizard from '@/components/pages/activator/RollWizard'

export default [
  {
    path: '/activator',
    redirect: '/activator/wizard',
    name: 'activator-home'
  }, {
    path: '/activator/calibrate',
    redirect: '/activator/v2/calibration',
    name: 'calibration',
  }, {
    path: '/activator/wizard',
    component: RollWizard
  }, {
    path: '/activator/v2/calibration',
    component: Calibration,
    meta: {
      title: 'Roll Calibration',
      icon: 'fa fa-film'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/activator.js